<fui-numeric-control [(ngModel)]="value" [placeholder]="placeholder" [attr.id]="elementId"
                     [decimals]="decimals" [showClear]="showClear"
                     [removable]="removable"
                     [label]="label"
                     (removed$)="onRemove()"></fui-numeric-control>
